import React, { useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
// import { OTISRecords } from "./OtisHelper";
import { OTISRecords, getRollupForChannel, compareRollups } from "./OtisHelper";
import { TableRowProps } from "@mui/material";
import { AppDispatch, RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { DataProp } from "../../common-components/TypesofInterfaces";
import { fetchCustomerAccounts } from "./TableBody/FetchCustomerAccounts";
import { FilterOTISData, FilterOTISDataById } from "./TableBody/FilterOTISData";
import { formatNumber } from "../../utils/formatNumber";
import {
  buildOtisFormFieldKey,
  findOrganization,
  findAccount,
  matchesOrganization,
  matchesAccount,
  matchesDistributionChannel,
} from "../../utils/otisCombinationUtils";
import {
  clearSelection,
  setSelectedAccountId,
  setSelectedOrgId,
  setSelectedRepId,
  setExistedRow,
} from "../../redux/reducers/Validationslice";
import {
  setCurrentPage,
  setSearchTerm,
  setDebouncedSearchTerm,
  setSelectedAccountName,
  setSelectedOrganization,
  setselectedDistribution,
  setShouldClear,
  setFinalData,
  setIsScroll,
  setInputtedData,
} from "../../redux/reducers/OTISReducer";
import TableRow from "./TableBody/TableRow";
import { produce } from "immer"; // Corrected: Import produce as a named export
import { toast } from "react-toastify";

/** Organizations that keep their own line, per channel. Everything else in
 *  the channel folds into that channel's All Other row. */
const NAMED_ORGS: Record<string, string[]> = {
  ONLRET:   ["90001403", "Shopify"],               // Amazon
  NATCHAIN: ["90000916", "90000005"],              // B&N, BAM
  DISTRADE: ["90001243", "90001159", "90001575"],  // Ingram, Brodart, Bookazine
  EDULIB:   ["96422973", "96235978", "90000370"],  // Follett SS, JLG/AKJ, BTSB
  BOOKCLUB: ["90000478", "14221549"],              // Scholastic, Literati
  AMCA:     ["96296554"],                          // Amazon Canada
  INDG:     ["90002074"],                          // Indigo
  RETINDEP: [], MUSEUM: [], SMIND: [],
  SPWHOL:   [], SMCHAIN: [], COMICSTR: [],
  "INTL AB": [],
  ANZ: ["T&H"],
};

const isAllOtherOrg = (org: any) =>
  String(org?.orgName ?? "").trim().toLowerCase() === "all other";

const COMP_FOLD_FIELDS = ["compInit", "compGross", "compNet", "Cpos_LTD"] as const;

const compNum = (val: any): number => {
  const raw = val != null && typeof val === "object" ? val.$numberDecimal : val;
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
};

interface SelectOption {
  label: string;
  value: string;
}

const TableBody: React.FC<DataProp> = ({
  data,
  setLoadingTest,
  LoadingTest,
  setModal,
  setGrandTotal,
  tableRef,
  formData,
  setFormData,
  handleRemoveRow,
               setText

}) => {
  const { setValue } = useForm();
  const dispatch = useDispatch<AppDispatch>();
  const [selectKey, setSelectKey] = useState(0);
  const selectRef = useRef<any>(null);
  const repcodeRef = useRef<any>(null);
  const OrgRef = useRef<any>(null);
   const eanSelectedValue = useSelector(
      (state: RootState) => state.OTISReducer.data.eanSelectedValue
    );

  const selectedDistribution = useSelector(
    (state: RootState) => state.OTISReducer.selectedDistribution
  );
  let tableData = useSelector(
    (state: RootState) => state.OTISReducer?.data?.SEGOTISRecords || []
  );
  let finalData = useSelector(
    (state: RootState) => state.OTISReducer?.data?.finalData || []
  );
  const selectedOrganization = useSelector(
    (state: RootState) => state.OTISReducer.selectedOrganization
  );
  const selectedAccountName = useSelector(
    (state: RootState) => state.OTISReducer.selectedAccountName
  );

  const repCodeSearchOptions = useSelector(
    (state: RootState) => state.OTISReducer.repCodeSearchOptions
  );
  const organizationSearchOptions = useSelector(
    (state: RootState) => state.OTISReducer.organizationSearchOptions
  );

  const accountSearchOptions = useSelector(
    (state: RootState) => state.OTISReducer.accountSearchOptions
  );

  const shouldClear = useSelector(
    (state: RootState) => state.OTISReducer.shouldClear
  );


  const debouncedSearchTerm = useSelector(
    (state: RootState) => state.OTISReducer.debouncedSearchTerm
  );
  const searchTerm = useSelector(
    (state: RootState) => state.OTISReducer.searchTerm
  );
  const hasMore = useSelector((state: RootState) => state.OTISReducer.hasMore);
  const currentPage = useSelector(
    (state: RootState) => state.OTISReducer.currentPage
  );
  const selectedRepIDS = useSelector<RootState, SelectOption | null>(
    (state) => state.selection.selectedRepID
  );
  const selectedOrgIDs = useSelector<RootState, SelectOption | null>(
    (state) => state.selection.selectedOrgID
  );
  const selectedAccountIDs = useSelector<RootState, SelectOption | null>(
    (state) => state.selection.selectedAccountID
  );

  const inputtedData = useSelector(
    (state: RootState) => state.OTISReducer.inputtedData
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      dispatch(setDebouncedSearchTerm(searchTerm));
    }, 800);
    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  // Single effect for account dropdown data (replaces separate currentPage + debouncedSearchTerm
  // effects that duplicated the same request on mount).
  useEffect(() => {
    fetchCustomerAccounts(
      debouncedSearchTerm,
      selectedRepIDS?.value || "",
      selectedOrgIDs?.value || "",
      selectedAccountIDs?.value || "",
      currentPage,
      dispatch
    );
    if (!hasMore) {
      dispatch(setIsScroll(false));
    }
  }, [
    debouncedSearchTerm,
    currentPage,
    hasMore,
    selectedRepIDS?.value,
    selectedOrgIDs?.value,
    selectedAccountIDs?.value,
    dispatch,
  ]);

  const clearValuesAndFetch = () => {
    dispatch(clearSelection());
    dispatch(setSelectedOrgId(null));
    dispatch(setSelectedAccountId(null));
    dispatch(setSelectedRepId(null));
    fetchCustomerAccounts();
    setSelectKey((prevKey) => prevKey + 1);
  };

  const handleFieldChange = (
    recordId: string,
    orgId: string,
    accountId: string,
    field: string,
    value: any,
    orgName?: string | null,
    accountName?: string | null
  ) => {
    const name = buildOtisFormFieldKey({
      recordId,
      orgId: orgId || null,
      orgName,
      accountId: accountId || null,
      accountName,
      field,
      isMainRow: !orgId && !accountId,
      isOrgLevelRow: !!orgId && !accountId,
    });

    if (value != undefined && value.toString().trim() !== " ") {
      // Keep field echo fast: lightweight local update first.
      setFormData((prev) => {
        if (prev[name] === value) return prev;
        return { ...prev, [name]: value };
      });

      // Update Redux state (finalData) using Immer
      dispatch(
        setFinalData(
          produce(
            finalData.length > 0 ? finalData : tableData,
            (draft: Record<string, any>[]) => {
              // Explicitly typed draft
              if (recordId) {
                // Existing row logic
                const recordToUpdate = draft.find(
                  (record: any) => record._id === recordId
                );
                if (recordToUpdate) {
                  if (!orgId && !accountId) {
                    // Main row fields (pub_goal, currEst, suppEst, sales_notes)
                    recordToUpdate.status = 0;
                    if (field === "sales_notes") {
                      recordToUpdate.main_sales_notes = value || "";
                    } else {
                      const fieldName =
                        field === "pub_goal"
                          ? "main_pubgoal"
                          : field === "currEst"
                          ? "main_current_estimate"
                          : field === "printmtdDate"
                          ? "main_print_meeting_date"
                          : "main_supplemental_estimate";
                      recordToUpdate[fieldName] = value === "" ? null : value;
                    }
                  } else if (orgId && !accountId) {
                    // Organization-level fields (Laydown Goal, Laydown Estimate, 6-Month Estimate, sales_notes)
                    recordToUpdate.status = 0;
                    const orgToUpdate = findOrganization(
                      recordToUpdate.organizations,
                      orgId,
                      orgName
                    );
                    if (orgToUpdate) {
                      orgToUpdate.status = 0;
                      if (field === "sales_notes") {
                        orgToUpdate.org_sales_notes = value || "";
                      } else {
                        const orgFieldName =
                          field === "pub_goal"
                            ? "org_pub_goal"
                            : field === "currEst"
                            ? "org_current_estimate"
                            : field === "suppEst"
                            ? "org_supplemental_estimate"
                            : null;
                        if (orgFieldName) {
                          orgToUpdate[orgFieldName] = value === "" ? null : value;
                        }
                      }
                    }
                  } else {
                    // Nested account fields
                    recordToUpdate.status = 0; // Mark as updated
                    const orgToUpdate = findOrganization(
                      recordToUpdate.organizations,
                      orgId,
                      orgName
                    );
                    if (orgToUpdate) {
                      orgToUpdate.status = 0; // Mark as updated
                      const accountToUpdate = findAccount(
                        orgToUpdate.accounts,
                        accountId,
                        accountName
                      );
                      if (accountToUpdate) {
                        accountToUpdate[field] =
                          field === "sales_notes"
                            ? value
                            : { $numberDecimal: value.toString() };
                        accountToUpdate.status = 0; // Mark as updated
                      }
                    }
                  }
                }
              } else {
                // New row logic (adapted for Immer's mutable draft pattern)
                const newDistId = selectedRepIDS?.value || "";
                const newDistName = selectedRepIDS?.label || "";
                const newOrgId = selectedOrgIDs?.value || "";
                const newOrgName = selectedOrgIDs?.label || "";
                const newAccountId = selectedAccountIDs?.value || "";
                const newAccountName = selectedAccountIDs?.label || "";

                let dist = draft.find((d: any) =>
                  matchesDistributionChannel(d, {
                    DISTRIBUTION_CHANNEL: newDistId,
                    DISTRIBUTION_CHANNEL_NAME: newDistName,
                  })
                );

                if (!dist) {
                  dist = {
                    DISTRIBUTION_CHANNEL: newDistId,
                    DISTRIBUTION_CHANNEL_NAME: newDistName,
                    organizations: [],
                  };
                  draft.push(dist);
                }

                let org = findOrganization(
                  dist.organizations,
                  newOrgId,
                  newOrgName
                );

                if (!org) {
                  org = {
                    organizationId: newOrgId,
                    orgName: newOrgName,
                    accounts: [],
                  };
                  dist.organizations.push(org);
                }

                let account = findAccount(
                  org.accounts,
                  newAccountId,
                  newAccountName
                );

                if (!account) {
                  account = {
                    accountName: newAccountName,
                    accountNumber: newAccountId,
                  };
                  org.accounts.push(account);
                }
                account[field] = value;
              }
            }
          )
        )
      );
    }
      localStorage.setItem("saveFlag", "true");
  dispatch(setInputtedData(true));
  };

  useEffect(() => {
    const getFromStorage = (
      key: string,
      defaultValue: SelectOption = { label: "", value: "" }
    ) => {
      try {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : defaultValue;
      } catch (error) {
        console.error(`Error parsing ${key} from localStorage:`, error);
        return defaultValue;
      }
    };

    const storedData = getFromStorage("savedFilterState");
    const saveFlag = localStorage.getItem("saveFlag") === "true";
    const { selectedOrgIDs, selectedAccountIDs, selectedRepIDS } = storedData;

    const distri = getFromStorage(
      "selectedDistribution",
      selectedRepIDS || { label: "", value: "" }
    );
    const org = getFromStorage(
      "selectedAboveOrganization",
      selectedOrgIDs || { label: "", value: "" }
    );
    const account = getFromStorage(
      "selectedAboveAccountName",
      selectedAccountIDs || { label: "", value: "" }
    );

    if (distri?.label) setValue("AboveDistribution", distri);
    if (org?.label) setValue("AboveOrganization", org);
    if (account?.label) setValue("AboveAccountName", account);

    dispatch(setselectedDistribution(distri?.label || ""));
    dispatch(setSelectedOrganization(org?.label || ""));
    dispatch(setSelectedAccountName(account?.label || ""));

    if (saveFlag && selectedOrgIDs && selectedAccountIDs && selectedRepIDS) {
      setValue("AboveDistribution", selectedRepIDS);
      setValue("AboveOrganization", selectedOrgIDs);
      setValue("AboveAccountName", selectedAccountIDs);

      dispatch(setselectedDistribution(selectedRepIDS?.label || ""));
      dispatch(setSelectedOrganization(selectedOrgIDs?.label || ""));
      dispatch(setSelectedAccountName(selectedAccountIDs?.label || ""));

      localStorage.removeItem("savedFilterState");
      localStorage.removeItem("saveFlag");
    }
  }, [setValue, dispatch]);

  useEffect(() => {
    if (inputtedData) {
      if (selectedRepIDS) {
        localStorage.setItem(
          "selectedDistribution",
          JSON.stringify(selectedRepIDS)
        );
      }
      if (selectedOrgIDs) {
        localStorage.setItem(
          "selectedAboveOrganization",
          JSON.stringify(selectedOrgIDs)
        );
      }
      if (selectedAccountIDs) {
        localStorage.setItem(
          "selectedAboveAccountName",
          JSON.stringify(selectedAccountIDs)
        );
      }
    }
  }, [selectedRepIDS, selectedOrgIDs, selectedAccountIDs, inputtedData]);

  const hasValidFormData = Object.entries(formData).some(
    ([key, value]) =>
      key.startsWith("null---") &&
      value !== null &&
      value !== undefined &&
      value.toString().trim() !== ""
  );

  useEffect(() => {
    const organizationId = selectedOrgIDs?.value;
    const accountId = selectedAccountIDs?.value;
    const distributionId = selectedRepIDS?.value;

    const filterState = { selectedOrgIDs, selectedAccountIDs, selectedRepIDS };

    // Persist when any single filter is selected (for persistent filter across ISBN navigation)
    const hasAnyFilter =
      (selectedRepIDS?.value != null && selectedRepIDS.value !== "") ||
      (selectedOrgIDs?.value != null && selectedOrgIDs.value !== "") ||
      (selectedAccountIDs?.value != null && selectedAccountIDs.value !== "");
    if (hasAnyFilter) {
      localStorage.setItem("savedFilterState", JSON.stringify(filterState));
    } else {
      localStorage.removeItem("savedFilterState");
    }

    const orgName = selectedOrgIDs?.label || null;
    const accountName = selectedAccountIDs?.label || null;
    const distName = selectedRepIDS?.label || null;

    const existingRow = data.find(
      (row) =>
        matchesDistributionChannel(row, {
          DISTRIBUTION_CHANNEL: distributionId,
          DISTRIBUTION_CHANNEL_NAME: distName,
        }) &&
        row.organizations.some(
          (org: any) =>
            matchesOrganization(org, {
              organizationId,
              orgName,
            }) &&
            org.accounts.some((acc: any) =>
              matchesAccount(acc, { accountNumber: accountId, accountName })
            )
        )
    );

    const ExistingOrganization = existingRow?.organizations.find((org: any) =>
      matchesOrganization(org, { organizationId, orgName })
    );
    const existingAccount = ExistingOrganization?.accounts?.find((acc: any) =>
      matchesAccount(acc, { accountNumber: accountId, accountName })
    );

    if (
      selectedOrgIDs &&
      selectedAccountIDs &&
      selectedRepIDS &&
      existingRow &&
      ExistingOrganization &&
      existingAccount
    ) {
      dispatch(setselectedDistribution(selectedRepIDS?.label));
      dispatch(setSelectedOrganization(selectedOrgIDs?.label));
      dispatch(setSelectedAccountName(selectedAccountIDs?.label));
      dispatch(setExistedRow(true));
      dispatch(setShouldClear(true));

      handleRemoveRow();
      // dispatch(setSelectedRepId(null));
      // dispatch(setSelectedAccountId(null));
      // dispatch(setSelectedOrgId(null));
    }
  }, [selectedAccountIDs, selectedOrgIDs, selectedRepIDS, hasValidFormData]);

  // Use Redux tableData (always latest after fetch), not `data` prop which can be stale after navigation.
  const dataForFilterCheck = tableData ?? [];

  // Apply persisted filters when tableData changes (e.g. after ISBN navigation). Match by ID; if no match, toast and clear.
  useEffect(() => {
    let saved: { selectedRepIDS?: SelectOption | null; selectedOrgIDs?: SelectOption | null; selectedAccountIDs?: SelectOption | null } = {};
    try {
      const raw = localStorage.getItem("savedFilterState");
      if (!raw) return;
      saved = JSON.parse(raw);
    } catch {
      return;
    }
    const distId = saved.selectedRepIDS?.value;
    const orgId = saved.selectedOrgIDs?.value;
    const accNum = saved.selectedAccountIDs?.value;
    const hasPersistedFilter =
      (distId != null && distId !== "") ||
      (orgId != null && orgId !== "") ||
      (accNum != null && accNum !== "");
    if (!hasPersistedFilter) return;

    const filteredById = FilterOTISDataById(
      dataForFilterCheck,
      distId || null,
      orgId || null,
      accNum || null,
      saved.selectedOrgIDs?.label || null,
      saved.selectedAccountIDs?.label || null,
      saved.selectedRepIDS?.label || null
    );
    const filteredByName = FilterOTISData(
      dataForFilterCheck,
      saved.selectedRepIDS?.label ?? undefined,
      saved.selectedOrgIDs?.label ?? undefined,
      saved.selectedAccountIDs?.label ?? undefined
    );
    const noMatchById = filteredById.length === 0;
    const noMatchByName = filteredByName.length === 0;

    if (noMatchById || noMatchByName) {
      toast.info("Accounts does not exist for selected filter.", { toastId: "otis-filter-no-match" });
      dispatch(setselectedDistribution(null));
      dispatch(setSelectedOrganization(null));
      dispatch(setSelectedAccountName(null));
      dispatch(setSelectedRepId(null));
      dispatch(setSelectedOrgId(null));
      dispatch(setSelectedAccountId(null));
      localStorage.removeItem("savedFilterState");
      localStorage.removeItem("saveFlag");
      return;
    }

    // Only restore Redux when it doesn't already match (avoid re-dispatching on every render)
    const alreadyApplied =
      (selectedRepIDS?.value ?? "") === (distId ?? "") &&
      (selectedOrgIDs?.value ?? "") === (orgId ?? "") &&
      (selectedAccountIDs?.value ?? "") === (accNum ?? "");
    if (alreadyApplied) return;

    const firstRecord = filteredById[0];
    if (!firstRecord || firstRecord.isNew) return;
    const distLabel = firstRecord.DISTRIBUTION_CHANNEL_NAME ?? saved.selectedRepIDS?.label ?? "";
    const firstOrg = firstRecord.organizations?.[0];
    const orgLabel = firstOrg?.orgName ?? saved.selectedOrgIDs?.label ?? "";
    const firstAccount = firstOrg?.accounts?.[0];
    const accountLabel = firstAccount?.accountName ?? saved.selectedAccountIDs?.label ?? "";

    const repOption = distId != null && distId !== "" ? { value: distId, label: distLabel } : null;
    const orgOption = orgId != null && orgId !== "" ? { value: orgId, label: orgLabel } : null;
    const accOption = accNum != null && accNum !== "" ? { value: accNum, label: accountLabel } : null;

    if (repOption) {
      dispatch(setSelectedRepId(repOption));
      dispatch(setselectedDistribution(repOption.label));
    }
    if (orgOption) {
      dispatch(setSelectedOrgId(orgOption));
      dispatch(setSelectedOrganization(orgOption.label));
    }
    if (accOption) {
      dispatch(setSelectedAccountId(accOption));
      dispatch(setSelectedAccountName(accOption.label));
    }
  }, [dataForFilterCheck, dispatch, selectedRepIDS?.value, selectedOrgIDs?.value, selectedAccountIDs?.value]);

  // Fallback: when display filtered result is empty but filters are selected (e.g. after navigation), clear and toast.
  useEffect(() => {
    const hasFilter =
      Boolean(selectedDistribution) ||
      Boolean(selectedOrganization) ||
      Boolean(selectedAccountName);
    if (!hasFilter) return;
    if (dataForFilterCheck.length === 0) return;

    const displayFiltered = FilterOTISData(
      dataForFilterCheck,
      selectedDistribution,
      selectedOrganization,
      selectedAccountName
    );
    if (displayFiltered.length === 0) {
      toast.info("Accounts does not exist for selected filter.", { toastId: "otis-filter-no-match" });
      dispatch(setselectedDistribution(null));
      dispatch(setSelectedOrganization(null));
      dispatch(setSelectedAccountName(null));
      dispatch(setSelectedRepId(null));
      dispatch(setSelectedOrgId(null));
      dispatch(setSelectedAccountId(null));
      localStorage.removeItem("savedFilterState");
      localStorage.removeItem("saveFlag");
    }
  }, [dataForFilterCheck, selectedDistribution, selectedOrganization, selectedAccountName, dispatch]);

  const filteredData = useMemo(() => {
    return FilterOTISData(
      data,
      selectedDistribution,
      selectedOrganization,
      selectedAccountName
    );
  }, [
    data,
    selectedDistribution,
    selectedOrganization,
    selectedAccountName,
    tableData,
  ]);

  
    /** Fold un-named organizations into their channel's All Other row.
   *  Only organizations listed in NAMED_ORGS keep a line of their own;
   *  everything else in that channel has its units and comp values summed into All Other. */
  const foldedData = useMemo(() => {
    return filteredData.map((record: any) => {
      const code = String(record?.DISTRIBUTION_CHANNEL ?? "").trim().toUpperCase();
      const named = NAMED_ORGS[code];
      if (!named) return record;

      const orgs = record.organizations ?? [];
      const allOther = orgs.find(isAllOtherOrg);
      if (!allOther) return record;

      const keep: any[] = [];
      let foldedUnits = 0;
      let foldedLtdUnits = 0;
      let foldedCount = 0;
      const foldedComp: Record<string, number> = {
        compInit: 0,
        compGross: 0,
        compNet: 0,
        Cpos_LTD: 0,
      };

      orgs.forEach((org: any) => {
        if (isAllOtherOrg(org)) return;
        if (named.includes(String(org?.organizationId ?? "").trim())) {
          keep.push(org);
          return;
        }
        (org.accounts ?? []).forEach((a: any) => {
          foldedUnits += Number(a?.units) || 0;
          foldedLtdUnits += Number(a?.ltdUnits) || 0;
          COMP_FOLD_FIELDS.forEach((f) => {
            foldedComp[f] += compNum(a?.[f]);
          });
        });
        foldedCount++;
      });

      if (!foldedCount) return record;

      const foldedAllOther = {
        ...allOther,
        accounts: (allOther.accounts ?? []).map((a: any, i: number) =>
          i === 0
            ? {
                ...a,
                units: (Number(a?.units) || 0) + foldedUnits,
                ltdUnits: (Number(a?.ltdUnits) || 0) + foldedLtdUnits,
                ...Object.fromEntries(
                  COMP_FOLD_FIELDS.filter((f) => foldedComp[f] !== 0).map((f) => [
                    f,
                    String(compNum(a?.[f]) + foldedComp[f]),
                  ])
                ),
              }
            : a
        ),
      };

      return { ...record, organizations: [foldedAllOther, ...keep] };
    });
  }, [filteredData]);
  /** Group filtered records by SEG rollup, preserving ROLLUP_ORDER. */
  const groupedByRollup = useMemo(() => {
    const groups = new Map<string, any[]>();
    foldedData.forEach((record: any) => {
      if (record?.isNew) return;
      const rollup = getRollupForChannel(record?.DISTRIBUTION_CHANNEL);
      if (!groups.has(rollup)) groups.set(rollup, []);
      groups.get(rollup)!.push(record);
    });
    return [...groups.entries()].sort((a, b) => compareRollups(a[0], b[0]));
  }, [foldedData]);

  /** Sum one numeric field across every account in a rollup's channels. */
  const sumRollupField = (records: any[], field: string): number => {
    let total = 0;
    records.forEach((record: any) => {
      record.organizations?.forEach((org: any) => {
        org.accounts?.forEach((account: any) => {
          const key = buildOtisFormFieldKey({
            recordId: record._id,
            orgId: org.organizationId,
            orgName: org.orgName,
            accountId: account.accountNumber,
            accountName: account.accountName,
            field,
          });
          const raw =
            formData?.[key] ??
            account?.[field]?.$numberDecimal ??
            account?.[field];
          const n = Number(raw);
          if (Number.isFinite(n)) total += n;
        });
      });
    });
    return total;
  };
  /**
   * Total an estimate field for one rollup using the same precedence as the
   * grid footer: channel-level value if set, else sum of org-level values,
   * else sum of account-level values.
   */
  const sumRollupEstimate = (
    records: any[],
    field: "pub_goal" | "currEst" | "suppEst"
  ): number => {
    const num = (val: any): number | null => {
      if (val == null) return null;
      const raw =
        typeof val === "object" && val?.$numberDecimal != null
          ? val.$numberDecimal
          : val;
      if (raw === "") return null;
      const n = Number(raw);
      return Number.isFinite(n) ? n : null;
    };
    const isSet = (val: any) => {
      const n = num(val);
      return n != null && n !== 0;
    };
    const mainField =
      field === "pub_goal"
        ? "main_pubgoal"
        : field === "currEst"
        ? "main_current_estimate"
        : "main_supplemental_estimate";
    const orgField =
      field === "pub_goal"
        ? "org_pub_goal"
        : field === "currEst"
        ? "org_current_estimate"
        : "org_supplemental_estimate";

    let rollupTotal = 0;

    records.forEach((record: any) => {
      // 1) channel level wins
      const mainKey = `${record._id}---${field}`;
      const mainVal = formData?.[mainKey] ?? record?.[mainField];
      if (isSet(mainVal)) {
        rollupTotal += num(mainVal) ?? 0;
        return;
      }

      // 2) otherwise sum org level
      let orgSum = 0;
      let anyOrg = false;
      record.organizations?.forEach((org: any) => {
        const orgKey = buildOtisFormFieldKey({
          recordId: record._id,
          orgId: org.organizationId,
          orgName: org.orgName,
          field,
          isOrgLevelRow: true,
        });
        const orgVal = formData?.[orgKey] ?? org?.[orgField];
        if (isSet(orgVal)) {
          anyOrg = true;
          orgSum += num(orgVal) ?? 0;
        }
      });
      if (anyOrg) {
        rollupTotal += orgSum;
        return;
      }

      // 3) otherwise sum accounts
      record.organizations?.forEach((org: any) => {
        org.accounts?.forEach((account: any) => {
          const accKey = buildOtisFormFieldKey({
            recordId: record._id,
            orgId: org.organizationId,
            orgName: org.orgName,
            accountId: account.accountNumber,
            accountName: account.accountName,
            field,
          });
          const accVal = formData?.[accKey] ?? account?.[field];
          rollupTotal += num(accVal) ?? 0;
        });
      });
    });

    return rollupTotal;
  };

  const newRecord = useMemo(
    () => ({
      _id: "new-row",
      isNew: true,
      repCode: "",
      organizations: [
        {
          organizationId: "new-org",
          orgName: "",
          accounts: [
            {
              accountNumber: "new-acc",
              accountName: "",
              units: "",
            },
          ],
        },
      ],
    }),
    []
  );

  const combinedData = useMemo(
    () => [newRecord, ...filteredData],
    [filteredData, newRecord]
  );

  useEffect(() => {
  if (filteredData.length === 0 || !eanSelectedValue) {
    setText(""); 
    return;
  }

   setText("Comparing Comp Title , Please Wait") 

  const timeout = setTimeout(() => {
    setText(""); 
  }, 0); 

  return () => clearTimeout(timeout);
}, [filteredData]);



  return (
    <tbody className="borderInputs">
      {filteredData.length > 0 ? (
       groupedByRollup.map(([rollupName, records]) => (
          <React.Fragment key={`rollup-${rollupName}`}>
            <tr className="bg-gray-200 font-semibold">
              <td colSpan={2} className="px-3 py-2 text-left borderInputs borderInputs-first sticky left-0 bg-gray-200 z-[4] min-w-[150px] overflow-hidden text-ellipsis align-middle" style={{ left: "var(--frz-l1)", borderLeft: "1px solid #ccc", borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc" }}>
                {rollupName}
              </td>
              <td className="px-2 py-2 text-center borderInputs sticky bg-gray-200 z-[4] min-w-[100px] align-middle" style={{ left: "var(--frz-l3)", borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc" }}>
                {formatNumber(sumRollupField(records, "units"))}
              </td>
              <td className="px-2 py-2 text-center borderInputs sticky bg-gray-200 z-[4] min-w-[100px] align-middle" style={{ left: "var(--frz-l4)", borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc" }}>
                {formatNumber(sumRollupField(records, "ltdUnits"))}
              </td>
              <td className="borderInputs"></td>
              <td className="px-2 py-2 text-center borderInputs hidden align-middle">
                {formatNumber(sumRollupEstimate(records, "pub_goal") || "")}
              </td>
              <td className="px-2 py-2 text-center borderInputs">
                {formatNumber(sumRollupEstimate(records, "currEst") || "")}
              </td>
              <td className="px-2 py-2 text-center borderInputs">
                {formatNumber(sumRollupEstimate(records, "suppEst") || "")}
              </td>
              <td className="px-2 py-2 text-center borderInputs">
                {formatNumber(sumRollupField(records, "compInit"))}
              </td>
              <td className="px-2 py-2 text-center borderInputs">
                {formatNumber(sumRollupField(records, "compGross"))}
              </td>
              <td className="px-2 py-2 text-center borderInputs">
                {formatNumber(sumRollupField(records, "compNet"))}
              </td>
              <td className="px-2 py-2 text-center borderInputs">
                {formatNumber(sumRollupField(records, "Cpos_LTD"))}
              </td>
            </tr>
            {records.map((record: any, index: number) => (
              <React.Fragment key={record?._id || `row-${index}`}>
                <TableRow
                  record={record}
                  index={index}
                  formData={formData}
                  handleFieldChange={handleFieldChange}
                  selectKey={selectKey}
                  repCodeSearchOptions={repCodeSearchOptions}
                  organizationSearchOptions={organizationSearchOptions}
                  accountSearchOptions={accountSearchOptions}
                  searchTerm={searchTerm}
                  setSearchTerm={(value: string) => dispatch(setSearchTerm(value))}
                  currentPage={currentPage}
                  setCurrentPage={(value: number) => dispatch(setCurrentPage(value))}
                  selectedRepIDS={selectedRepIDS}
                  selectedOrgIDs={selectedOrgIDs}
                  selectedAccountIDs={selectedAccountIDs}
                  fetchCustomerAccounts={fetchCustomerAccounts}
                  dispatch={dispatch}
                  setSelectedRepId={(val: any) => dispatch(setSelectedRepId(val))}
                  setSelectedOrgId={(val: any) => dispatch(setSelectedOrgId(val))}
                  setSelectedAccountId={(val: any) => dispatch(setSelectedAccountId(val))}
                  repcodeRef={repcodeRef}
                  OrgRef={OrgRef}
                  tableRef={tableRef}
                  selectRef={selectRef}
                  setModal={setModal}
                  shouldClear={shouldClear}
                  setGrandTotal={setGrandTotal}
                  setFormData={setFormData}
                />
              </React.Fragment>
            ))}
          </React.Fragment>
        ))
      ) : (
        <tr>
          <td colSpan={10} className="text-center py-2 text-gray-500">
            No records found
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default TableBody;
